import React from 'react'
import TermAndConditions from '../components/homepage/termConditions/TermConditions'

const TermConditions = () => {
  return (
    <TermAndConditions />
  )
}

export default TermConditions